import React, { useEffect, useState } from 'react';
import LinkifyText from './LinkifyText.js';
import { useParams} from 'react-router-dom';
import { API_BASE_URL } from '../scripts/control';

const PublicationDetail = () => {
    const { idpublication } = useParams(); // Obtenida de la URL
    const [publication, setPublication] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE_URL}/api/details.php?type=publication&id=${idpublication}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    setError(data.error);
                } else {
                    setPublication(data);
                }
            })
            .catch((error) => setError('Error al obtener los detalles de la publicación.'));
    }, [idpublication]);

    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`;
    };

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!publication) {
        return <div>Cargando detalles de la publicación...</div>;
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <div className="card" style={{ maxWidth: '900px', margin: '20px auto', padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
            <div className="card-body m-2">
                <h1 className="card-title">{publication.title}</h1>
                <img
                    src={publication.img_url 
                            ? `${API_BASE_URL}/public/uploads/images/${publication.img_url}` 
                            : `${API_BASE_URL}/public/uploads/images/comic.jpg`} 
                    alt={publication.img_alt || 'Imagen de la publicación'}
                    style={{ width: '100%', maxHeight: '400px', objectFit: 'cover', marginBottom: '20px', marginLeft: '-2%' }}
                />
                <LinkifyText text={publication.body} />
                
                {publication.location && (
                    <p className="card-text">
                        <strong>Ubicación:</strong> {publication.location || 'No especificada'}
                    </p>
                )}
                
                {publication.day && publication.day !== '0000-00-00' && (
                    <p className="card-text">
                        <strong>Fecha:</strong> {formatDate(publication.day)}
                    </p>
                )}

                {publication.hour && publication.hour !== '00:00:00' && (
                    <p className="card-text">
                        <strong>Hora:</strong> {publication.hour || 'No especificada'}
                    </p>
                )}

                <button
                    className="btn btn-primary"
                    style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: '#005EC4', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                     onClick={scrollToTop}
                >
                    Subir
                </button>
            </div>
        </div>
    );
};

export default PublicationDetail;
